import React from 'react';
import ApplicationReviewStep from './ApplicationReview';
import { ContainerTemplate } from '@/components';

export const ApplicationReview = () => (
  <ContainerTemplate>
    <ApplicationReviewStep />
  </ContainerTemplate>
);
